import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import {
  RanchPageViewEnum,
  selectRanchPageView,
  setRanchFocusArea,
  setRanchPageView,
} from '../../../ranches/ranchesSlice';
import {
  ResetItemsEnum,
  resetSelectFields,
  setCurrBlockByID,
} from '../../../select/selectSlice';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';
import { HomeIcon } from '../icons/HomeIcon';
/**
 * Button to navigate to Ranch summary
 * If clicked in block detail view, it returns to ranch view
 */
export const RanchSummaryButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const ranchPageView = useAppSelector(selectRanchPageView);
  const dispatch = useAppDispatch();

  const active =
    location.pathname === '/' &&
    (ranchPageView === RanchPageViewEnum.ranchSummary ||
      ranchPageView === RanchPageViewEnum.blockDetail);

  return (
    <NavbarIconButtonWithLabel
      label={t('Summary')}
      active={active}
      onClick={() => {
        if (location.pathname !== '/') {
          navigate('/');
        }
        if (ranchPageView !== RanchPageViewEnum.ranchSummary) {
          dispatch(
            resetSelectFields([
              ResetItemsEnum.Scan,
              ResetItemsEnum.AllCubeRelatedFields,
            ])
          );
          dispatch(setCurrBlockByID(''));
          dispatch(setRanchPageView(RanchPageViewEnum.ranchSummary));
          dispatch(setRanchFocusArea(null));
        }
      }}
    >
      <HomeIcon />
    </NavbarIconButtonWithLabel>
  );
};
